module.exports = __webpack_public_path__ + "0a2b6fb8973ee1156ee77de06824a47c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/glyphs/y.png
// module id = 228
// module chunks = 0